import { createFileRoute } from '@tanstack/react-router';
import { buildCompareHead } from '../../../utils/seo';

export const Route = createFileRoute('/_layout/compare/$slug')({
  head: ({ params }) => buildCompareHead(params.slug),
});
